import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import OrgPlaceholderSvg from 'images/v5/icons/avatar-placeholder-org.svg';
import UserPlaceholderSvg from 'images/v5/icons/avatar-placeholder-user.svg';
import CameraIcon from 'images/v5/icons/camera-01.svg';
import styles from './Avatar.module.scss';
function Avatar({ userName, to, src, type = 'user', size = 'm', shape = 'round', as: Tag = 'div', showInitials = true, onClick, }) {
    const showingInitials = !src && showInitials && !!userName;
    const classes = classNames(styles.wrap, styles[size], styles[shape], {
        [styles.withInitials]: showingInitials,
    });
    function getInitials(name) {
        return name
            .split(' ')
            .filter(Boolean)
            .map((word) => word[0].toUpperCase())
            .join('');
    }
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    const placeholderIcon = {
        user: React.createElement(UserPlaceholderSvg, null),
        org: React.createElement(OrgPlaceholderSvg, null),
        image: React.createElement(CameraIcon, null),
    }[type];
    function renderContent() {
        if (src)
            return null;
        if (showingInitials)
            return React.createElement("span", { className: styles.initials }, getInitials(userName));
        return placeholderIcon;
    }
    const content = renderContent();
    if (to) {
        return (React.createElement(Link, { to: to, className: classes, style: { backgroundImage: `url(${src})` }, onClick: handleClick, title: userName }, content));
    }
    if (onClick) {
        return (React.createElement("button", { type: "button", className: classes, style: { backgroundImage: `url(${src})` }, onClick: handleClick, title: userName }, content));
    }
    return (React.createElement(Tag, { className: classes, style: { backgroundImage: `url(${src})` }, title: userName }, content));
}
export default Avatar;
